
















































































































import {
  defineComponent,
  ref,
  SetupContext,
  computed,
  onMounted,
  useContext,
  useRoute,
  useRouter,
  useStore,
  watch,
  onUnmounted,
  PropType,
} from '@nuxtjs/composition-api'
import queryString from 'query-string'
import BlockDadataWithIcon from '../components/BlockDadataWithIcon.vue'
import { capitalizeFirstLetter } from '@/composition/capitalizeFirstLetter'
import { Logger } from '@/composition/Logger'
import { sectionCoreProps } from '@/mixins/sectionCore'
import BlockMap from '@/components/BlockMap.vue'
import Loader from '@/plugins/loader/Load.vue'
import BlockTagRow from '@/components/Tags/BlockTagRow.vue'
import BlockOffice from '@/components/Cards/BlockOffice.vue'
import { useHeaderHeight } from '@/composition/headerHeight.ts'
import CardOfficeList from '@/components/CardLists/CardOfficeList.vue'
import {
  AdaptedOffice,
  Office,
  officeListAdapter,
} from '@/apollo/adapters/modules/officeAdapter'
import { yaHitPage } from '@/composition/ym'

type RouteParams = {
  type?: 'sale' | 'claim' | 'stat-agentom'
}

export default defineComponent({
  name: 'SectionOffices',
  components: {
    BlockDadataWithIcon,
    Loader,
    BlockMap,
    BlockTagRow,
    BlockOffice,
    CardOfficeList,
  },
  mixins: [sectionCoreProps],
  props: {
    notificationText: {
      type: String,
      default: '',
    },
    popup: {
      type: Boolean,
      default: false,
    },
    office: {
      type: Object as PropType<AdaptedOffice>,
    },
    isAgent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx: SetupContext) {
    const office = props.office
    const store = useStore()
    const reloadMap = ref(0)
    const showInfo = ref(false)
    const loading = ref(!office)
    const map = ref(null)
    const showDetailOfficeClickedNow = ref(false)
    const showReturnButton = ref(false)
    const selectedOffice = ref<any>(null)
    const tagsData = [
      {
        id: 'sale',
        linkText: 'офисы продаж',
      },
      {
        id: 'claim',
        linkText: 'урегулирование убытков',
      },
    ]
    const isDesktop = computed(
      () => ctx.root.$store.getters['mediaQuery/isDesktopMq']
    )
    const isInitedMap = computed(
      () => ctx.root.$store.getters['settings/getMapIsInit']
    )
    const region = computed(() => store.getters['region/getRegion'])
    // Фикс элементов на странице //
    const { headerHeight } = useHeaderHeight()

    const infoHeight = computed(() => ({
      '--block-height': isDesktop.value
        ? '100vh'
        : `calc(100vh - ${headerHeight.value}px -16.2rem)`,
      'background-color': '#fff',
    }))
    const isDetailOffices = ref(false)
    const currentValue = ref(0)
    const city = ref('Москва')
    const inputRegionData = ref('')
    const route = useRoute()
    const router = useRouter()
    const filter = {
      searchString: '',
      officeTag: tagsData[0].linkText,
    }
    // Аддрес заданный через поле поиска
    const address = ref('')
    // Координаты пользователя через геолокацию или по IP
    const userPosition = ref(null)
    // Флаг первичного посещения
    const notification = ref<boolean>(false)
    // ДАННЫЕ //
    const officesList = ref<ReturnType<typeof officeListAdapter>>(
      office ? [office] : []
    )
    const queryData = ref<ReturnType<typeof officeListAdapter>>(
      officesList.value
    )
    const zoomAddress = ref<number>(10)
    const showButton = () => {
      showReturnButton.value = true
    }
    const goToList = () => {
      showReturnButton.value = false
      map.value.zooming()
    }
    const onInputRegionFocus = () => {
      showInfo.value = false
    }

    const selectedOfficePopup = (office): void => {
      ctx.emit('change-ofiice', {
        name: office.title || office.address,
        value: office,
      })
      // ctx.emit('input-change', office)
      ctx.emit('hide-popup')
    }

    const onClickExit = () => {
      if (!props.popup) {
        const fromPath = ctx.root.context.from?.path
        const isPrevPageDetailed = fromPath?.includes(route.value.path)
        const allowedHistoryLength = window.history.length > 2

        // зашли на детальную страницу офиса, перешли на страницу всех офисов
        if (isPrevPageDetailed && allowedHistoryLength) {
          router.push('/')
        } else {
          // из-за router.go(-1) не работает скролл по бекстеку
          // поэтому сделали через history
          allowedHistoryLength ? history.go(-1) : router.push('/')
        }
      } else {
        ctx.emit('hide-popup')
      }
    }
    const onSwipeTop = (e) => {
      if (e.deltaY < 0) {
        showInfo.value = true
      }
    }
    const onSwipeBottom = (e) => {
      if (e.deltaY > 0) {
        showInfo.value = false
      }
    }
    const apiCtx = useContext()
    const mapCenter = { lat: 0, lng: 0 }
    const onBoundsChange = async (evt: any) => {
      if (!office && !showDetailOfficeClickedNow.value) {
        loading.value = true
        mapCenter.lat = (evt.left + evt.right) / 2
        mapCenter.lng = (evt.bottom + evt.top) / 2
        if (
          route.value.path.includes('about/career/stat-agentom') &&
          region.value &&
          region.value !== 'undefined'
        ) {
          const { data } = await apiCtx.$api.requests.getOffices({
            region: region.value,
            statAgentom: props.isAgent,
          })
          officesList.value = officeListAdapter(data.data as Office[])
          if (data.data.length < 1) {
            const resp = await apiCtx.$api.requests.getOfficesByBounds({
              ...evt,
              statAgentom: props.isAgent,
            })
            officesList.value = officeListAdapter(resp.data.data)
          }
        } else {
          const resp = await apiCtx.$api.requests.getOfficesByBounds({
            ...evt,
            statAgentom: props.isAgent,
          })
          officesList.value = officeListAdapter(resp.data.data)
        }

        getOffices(filter)
        // Очистить строку поиска если не пустая
        loading.value = false
      }
      showDetailOfficeClickedNow.value = false
    }
    const closeInCity: { name: string; distDescriptor: number } = {
      name: '',
      distDescriptor: Infinity,
    }
    const checkCloseCity = (office) => {
      const y = mapCenter.lat - office.coords[0]
      const x = mapCenter.lng - office.coords[1]
      const distDescriptor = y * y + x * x
      if (closeInCity.distDescriptor > distDescriptor) {
        closeInCity.distDescriptor = distDescriptor

        const cityBySpaces = office.city?.split(' ')
        closeInCity.name = cityBySpaces?.map(capitalizeFirstLetter)?.join(' ')

        const cityByHyphen = closeInCity.name?.split('-')
        if (cityByHyphen) {
          cityByHyphen[cityByHyphen.length - 1] = capitalizeFirstLetter(
            cityByHyphen.at(-1)
          )
          closeInCity.name = cityByHyphen.join('-')
        }
      }
    }

    watch(officesList, (newArr, oldArr) => {
      if (newArr.length > oldArr.length) {
        if (showReturnButton.value) {
          showReturnButton.value = false
        }
        if (isDetailOffices.value) {
          isDetailOffices.value = false
          selectedOffice.value = null
        }
      }
    })

    if (office) {
      selectedOffice.value = office
      isDetailOffices.value = true
    }

    const showOfficeList = (item?: Object) => {
      window.history.pushState(
        null,
        null,
        // eslint-disable-next-line camelcase
        `${route.value.path}?type=${currentValue.value}`
      )
      yaHitPage()
      showReturnButton.value = false
      isDetailOffices.value = false
      selectedOffice.value = item
      map.value.moveToCenterCart()
    }

    const showDetailOffice = (item?: Object) => {
      // eslint-disable-next-line camelcase
      const { country_translit, city_translit, id } = item
      const formattedCity = city_translit.replace(/ /g, '_')
      window.history.pushState(
        null,
        null,
        // eslint-disable-next-line camelcase
        `${route.value.path}/${country_translit}/${formattedCity}/${id}?type=${currentValue.value}`
      )
      yaHitPage()
      showDetailOfficeClickedNow.value = true
      showReturnButton.value = false
      isDetailOffices.value = true
      selectedOffice.value = item
      map.value.moveToOffice(item)
    }

    const onChange = (item: any) => {
      if (!props.office) {
        currentValue.value = item.id
        filter.officeTag = item.linkText
        const parsedQuery = getQueriesFromUrl()
        parsedQuery.type = item.id
        const queries = queryString.stringify(parsedQuery)
        const clearQueries = queries.trim().replaceAll(' ', '_')

        history.replaceState(
          {},
          null,
          route.value.path + `${clearQueries ? '?' + queries : ''}`
        )
        yaHitPage()
        getOffices(filter)
      }
    }

    const getQueriesFromUrl = () => {
      const searchQueries = queryString.parse(window.location.search)
      const queries = {}

      for (const key in searchQueries) {
        try {
          queries[key] = JSON.parse(searchQueries[key])
        } catch (e) {
          queries[key] = searchQueries[key]
        }
      }

      return queries
    }

    const getOffices = (query: any) => {
      closeInCity.name = ''
      closeInCity.distDescriptor = Infinity
      queryData.value = officesList.value.filter((item) => {
        if (item.type === query.officeTag) {
          checkCloseCity(item)
          return true
        }
        return false
      })
    }

    // получение гео с бекенда [на данный момент устанавливает г. Москва по дефолту]
    const getReg = ({ lat = 55.75322, lng = 37.622513 } = {}) => {
      if (!office) {
        city.value = 'Москва'
        userPosition.value = [lat, lng]
        mapCenter.lat = lat
        mapCenter.lng = lng

        return
      }
      const {
        city: cityOffice,
        coords: [_lat, _lng],
      } = office
      city.value = cityOffice
      userPosition.value = [_lat, _lng]
      mapCenter.lat = _lat
      mapCenter.lng = _lng
      zoomAddress.value = 14
    }
    // Функция получение гео позиции пользователя
    const getPosition = () => {
      const geoFail = (err = null) => {
        err && Logger.error(err, 'err')
        getReg()
      }
      if (navigator.geolocation) {
        const locationTimeout = setTimeout(geoFail, 3000)

        navigator.geolocation.getCurrentPosition(
          (resp) => {
            clearTimeout(locationTimeout)
            const { coords: { latitude = null, longitude = null } = {} } =
              resp || {}
            getReg({ lat: latitude, lng: longitude })
          },
          (err: any) => {
            clearTimeout(locationTimeout)
            geoFail(err)
          }
        )
      } else {
        geoFail()
      }
    }
    const onInput = (data: any) => {
      if (
        data.city &&
        !data.address.toLowerCase().includes(city.value.toLowerCase())
      ) {
        inputRegionData.value = data
        city.value = data.city.replace(/^(.{1,3}\s)/i, '')
        filter.searchString = city.value
      }
      // Строка адресса для позиционирования карты по адрессу
      address.value = data.address
      // Задает зум карты в зависимости от подробности адреса
      if (data.street) {
        zoomAddress.value = 14
      } else if (data.city) {
        zoomAddress.value = 10
      } else {
        zoomAddress.value = 10
      }
      map.value.moveCenterToAddress(address.value, zoomAddress.value)
      getOffices(filter)
    }

    const onInitWithRegion = () => {
      if (
        route.value.path.includes('about/career/stat-agentom') &&
        region.value
      ) {
        filter.searchString = region.value
        map.value.moveCenterToAddress(region.value, 7.5)
        getOffices(filter)
      }
    }

    const notFoundText = computed(() => {
      return queryData.value.length
        ? ''
        : 'Мы ничего не нашли.<br> Попробуйте выбрать другой адрес.'
    })
    const checkFirstVisit = () => {
      if (
        !document.cookie.split('; ').some((it) => it.startsWith('notification'))
      ) {
        notification.value = true
      }
    }
    const onNotificationCloseClick = () => {
      notification.value = false
      document.cookie =
        'notification=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; Secure'
    }
    watch(isDesktop, (val) => {
      store.commit('settings/SET_HIDE_HEADER', val)
      if (val) {
        reloadMap.value++
      }
    })
    watch(isInitedMap, (val) => {
      if (val) {
        onInitWithRegion()
      }
    })
    onMounted(() => {
      const query: RouteParams = route.value.query
      if (query.type === 'claim') {
        onChange(tagsData[1])
      } else {
        onChange(tagsData[0])
      }

      store.commit('settings/SET_HIDE_HEADER', isDesktop.value)
      store.commit('settings/SET_HIDE_FOOTER', true)
      getPosition()
      if (!office) {
        checkFirstVisit()
      }
    })

    onUnmounted(() => {
      store.commit('settings/SET_HIDE_HEADER', false)
      store.commit('settings/SET_HIDE_FOOTER', false)
    })

    if (!office) {
      getOffices(filter)
    }

    return {
      reloadMap,
      selectedOfficePopup,
      onInputRegionFocus,
      infoHeight,
      showInfo,
      apiCtx,
      onSwipeTop,
      onSwipeBottom,
      officesList,
      tagsData,
      queryData,
      currentValue,
      showOfficeList,
      showDetailOffice,
      onChange,
      onInput,
      zoomAddress,
      isDetailOffices,
      city,
      closeInCity,
      inputRegionData,
      notFoundText,
      selectedOffice,
      address,
      userPosition,
      notification,
      getReg,
      getPosition,
      checkFirstVisit,
      onNotificationCloseClick,
      onBoundsChange,
      loading,
      showButton,
      goToList,
      showReturnButton,
      map,
      onClickExit,
      onInitWithRegion,
    }
  },
})
